import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../../jsx/global-functions/checkErrors";
export const getSiteDataFunc = createAsyncThunk(
    "get site data function",
    async (api,thunkAPI) => {
        const token = window.localStorage.getItem("token")
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.get(api , config);
            if(response && response.data) {
                console.log(response.data)
                // const homeDataObj = response.data.data
                // window.localStorage.setItem("homeObj" , JSON.stringify(homeDataObj))
            }
            return response.data.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
        
    }
)

const getSiteDataSlicer = createSlice({
    name : "get site data slicer",
    initialState : {
        loading : null,
        data : null,
        error : null
    },
    reducer : {},
    extraReducers : (builder) => {
        builder.addCase(getSiteDataFunc.pending , (state) => {
            state.loading = true
            state.data = null
            state.error = null
        })
        builder.addCase(getSiteDataFunc.rejected , (state) => {
            state.loading = null
            state.data = null
            state.error = true
        })
        builder.addCase(getSiteDataFunc.fulfilled , (state , action) => {
            state.loading = false
            state.data = action.payload
            state.error = null
        })
    }
})

export default getSiteDataSlicer.reducer;